/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCellphone: {
  name: 'cellphone';
  data: string;
} = {
  name: 'cellphone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6Zm10 0v6H8V6h8Zm0 8H8v4h8v-4Zm-4 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
